// extracted by mini-css-extract-plugin
export default {"SeparateurBloc":"SeparateurBloc_SeparateurBloc__Ft9lh"};